<footer class="aic-landing-footer border-top py-4">
  <div class="container d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
    <small>&copy; {{rights.year}} {{rights.company_name}}. All rights reserved.</small>
    <small>Education progress, clearly tracked.</small>
  </div>
</footer>
